export default __webpack_public_path__ + "static/media/img-about-us.58d83e45.png";